'use client';

import {
  MyEquipmentHeader,
  MyEquipmentInfoToolTip,
  useBreakpoint
} from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import styles from '../add-equipment-drawer.module.scss';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { useFormContext } from 'react-hook-form';
import { useFeedback } from 'providers/feedback-provider';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const AddEquipmentHeader = () => {
  const t = useTranslations();
  const {
    addEquipmentDrawer: { closeDrawer, isChild }
  } = useMyEquipmentDrawer();
  const { dismissFeedback } = useFeedback();
  const { clearErrors, reset } = useFormContext();

  const resetFormAndCloseDrawer = () => {
    dismissFeedback();
    reset();
    clearErrors();
    closeDrawer();
  };
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.XL);

  return (
    <MyEquipmentHeader
      variant={'title-sm'}
      className="d-none d-md-flex"
      onBackButtonClick={isChild ? resetFormAndCloseDrawer : null}
    >
      <span>{t('ADD_EQUIPMENT_DRAWER_HEADING')}</span>
      <MyEquipmentInfoToolTip
        position="bottom"
        aria-label={`${t('PLEASE_NOTE')} ${t('MEQ_SUPPORTED_EQUIP1')}`}
        className={`${styles['equipment-header-tooltip']}`}
        label={t('MEQ_SUPPORTED_EQUIP1')}
        isInteractive={!isDesktop}
      >
        <span className="font-weight-bold mr-1">{t('PLEASE_NOTE')}&nbsp;</span>
      </MyEquipmentInfoToolTip>
    </MyEquipmentHeader>
  );
};
